module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 014.53448cd2.jpg";